module.exports = __webpack_public_path__ + "img/31.4a0b4462.png";